jQuery(document).ready(function onLanguagePickerReady($) {
    "use strict";

    var $pickers = $('.language-picker');
    $pickers.find('.language-picker__current').on('click', onTogglePickLanguage);
    $pickers.find('.language-picker__language--current').on('click', onClickCurrentLanguage);

    function onTogglePickLanguage(e) {
        var $current = $(this);
        var $picker = $current.parent();
        var $list = $picker.find('.language-picker__list');

        $picker.addClass('language-picker--open');
    }

    function onClickCurrentLanguage(e) {
        var $picker = $(this).parentsUntil('.language-picker').parent();
        $picker.removeClass('language-picker--open');
        $currentCatcher.remove();
    }
});